// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1rWMe","list":"PatternAutocomplete_list__3TFJn"};